module.exports = __webpack_public_path__ + "static/img/007.9313c0f2.png";